import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LinkBar from "../../LinkBar/LinkBar";
import Search from "../Search/Search";

const Serieses = () => {
  const { series } = useParams();
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    series &&
      fetch("https://apichothaon1-hzrifat.b4a.run/depts")
        .then((res) => res.json())
        .then((data) =>
          setDepartments(
            data?.map((d) => {
              return d?.code;
            })
          )
        );
  }, [series]);

  return (
    <div className="container row">
      <div className="col-md-4 col-sm-6 col-12 ms-0 ps-0">
        <Search />
      </div>
      <div className="col-md-8 col-sm-6 col-12">
        <LinkBar series={series} />
        <div className="row mt-5 mb-4 ">
          {departments?.length
            ? departments?.map((d, i) => {
                return (
                  <div
                    key={i}
                    className="col-md-3 col-sm-6 col-12 d-flex justify-content-center"
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      exact
                      to={`/collections/${series}/${d?.toLowerCase()}`}
                    >
                      <div className="folder-style">
                        <i
                          style={{ fontSize: "5rem" }}
                          className="fa-solid fa-folder"
                        ></i>
                        <p style={{ fontWeight: "500", fontSize: "1.1rem" }}>
                          {d}
                        </p>
                      </div>
                    </Link>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default Serieses;
